export default "__VITE_ASSET__BnTocZdB__"